// extracted by mini-css-extract-plugin
export default {"bottomDrawer":"bottomDrawer_bottomDrawer__GjcoA"};